module.exports = __webpack_public_path__ + "assets/images/project/united-kingdom.jpg?v=d712fc60";